module.exports = __webpack_public_path__ + "assets/media/lunch.a59a1be3.mp3";